export default __webpack_public_path__ + "static/media/71.d5b8818c.svg";